function addItemToCart(e, s) {
  (data = { id: e, quantity: s }),
    jQuery.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (e) {
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", { bubbles: !0 })
        ),
          document.documentElement.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: !0,
              detail: { variant: e.id, quantity: e.quantity },
            })
          );
      },
    });
}

  $(document).ready(function () {
    $(".logo-list.slider_logo_list_bs").slick({
      dots: !1,
      arrows: !1,
      infinite: !1,
      speed: 300,
      slidesToShow: 7,
      slidesToScroll: 4,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 4,
            autoplay: !0,
            infinite: !0,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: !0,
            autoplaySpeed: 4e3,
            infinite: !0,
            rows: 1,
          },
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            autoplay: !0,
            autoplaySpeed: 4e3,
            infinite: !0,
            rows: 1,
          },
        },
      ],
    }),
      console.log("ready!");
  }),
  $(".review-slider").slick({
    dots: !0,
    infinite: !0,
    speed: 500,
    center: !0,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: !1,
    autoplaySpeed: 5e3,
    arrows: !0,
    prevArrow: "<a  class='prev'></a>",
    nextArrow: "<a  class='next'></a>",
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      { breakpoint: 400, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  }),
  $(".Logo-slider").slick({
    dots: !0,
    infinite: !0,
    speed: 500,
    center: !0,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: !1,
    autoplaySpeed: 5e3,
    arrows: !0,
    prevArrow: "<a  class='prev'></a>",
    nextArrow: "<a  class='next'></a>",
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      {
        breakpoint: 400,
        settings: { arrows: !0, slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  }),
  $(".feature-product-slider").slick({
    dots: !0,
    infinite: !0,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: !1,
    autoplaySpeed: 5e3,
    arrows: !0,
    prevArrow: "<a  class='prev'></a>",
    nextArrow: "<a  class='next'></a>",
    responsive: [
      { breakpoint: 1177, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      {
        breakpoint: 600,
        settings: {
          arrows: !1,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: !0,
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: !1,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: !0,
        },
      },
    ],
  }),
  $(".coll-slider").slick({
    dots: !1,
    infinite: !0,
    speed: 500,
    center: !0,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: !1,
    autoplaySpeed: 5e3,
    arrows: !0,
    prevArrow: "<a  class='prev'></a>",
    nextArrow: "<a  class='next'></a>",
    responsive: [
      { breakpoint: 1100, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 991, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      {
        breakpoint: 600,
        settings: { slidesToShow: 2, slidesToScroll: 1, arrows: !1 },
      },
      {
        breakpoint: 400,
        settings: { arrows: !1, slidesToShow: 2, slidesToScroll: 1 },
      },
    ],
  }),
  $(".asking-default").slick({
    dots: !1,
    infinite: !0,
    speed: 500,
    center: !0,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: !1,
    autoplaySpeed: 5e3,
    arrows: !0,
    prevArrow: "<a  class='prev'></a>",
    nextArrow: "<a  class='next'></a>",
    responsive: [
      { breakpoint: 991, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !0,
          centerMode: !0,
          centerPadding: "60px",
        },
      },
      {
        breakpoint: 400,
        settings: {
          arrows: !0,
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: !0,
          centerMode: !0,
          centerPadding: "60px",
        },
      },
    ],
  }),
  $(".ingredients-slider").slick({
    dots: !0,
    infinite: !0,
    speed: 500,
    center: !0,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: !1,
    autoplaySpeed: 5e3,
    arrows: !0,
    prevArrow: "<a  class='prev'></a>",
    nextArrow: "<a  class='next'></a>",
    responsive: [
      { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      {
        breakpoint: 600,
        settings: {
          dots: !0,
          arrows: !1,
          center: !1,
          slidesToShow: 1.1,
          slidesToScroll: 1,
          infinite: !1,
        },
      },
    ],
  }),
  $(document).ready(function () {
    $(".j-slider-main").slick({
      infinite: !0,
      slidesToShow: 5,
      slidesToScroll: 5,
      dots: !0,
      center: !0,
      responsive: [
        { breakpoint: 600, settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });
  }),
  document.addEventListener("DOMContentLoaded", function () {
    $(document).on("click", ".ad_to_cart_coll", function () {
      setTimeout(function () {
        window.SLIDECART_UPDATE(), window.SLIDECART_OPEN();
      }, 500),
        setTimeout(function () {
          window.SLIDECART_UPDATE();
        }, 1e3);
    });
  }),
  document.addEventListener("DOMContentLoaded", function () {
    $(document).on("click", ".ad_to_cart_coll", function () {
      addItemToCart($(this).attr("data-var_id"), 1), console.log("NEWNEW");
    });
  }),
  $(".closenote").click(function () {
    $(".cartnote").hide();
  }),
  $(window).scroll(function (e) {
    $(window).width() > 300 &&
      ($(window).scrollTop() > 0
        ? (0 == $("#announcement-bar-with-slider").length &&
            $(".shopify-section--header"),
          $(".shopify-section--header").addClass("sticky_topbar"),
          $(".PageContainer").css("marginTop", "60px"))
        : ($(".shopify-section--header").removeClass("sticky_topbar"),
          $(".PageContainer").css("marginTop", "0")));
  }),
  $("#registerbtn").click(function (e) {
    var s = $("#firstname").val(),
      t = $("#lastname").val(),
      o = $("#email").val(),
      i = $("#phone").val(),
      l = $("#password").val(),
      n = 0;
    if (
      ($("#err-firstname").html(""),
      "" == s && ($("#err-firstname").html("First name is required!"), (n = 1)),
      $("#err-lastname").html(""),
      "" == t && ($("#err-lastname").html("Last name is required!"), (n = 1)),
      $("#err-email").html(""),
      "" == o
        ? ($("#err-email").html("Email is required!"), (n = 1))
        : /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(
            o
          ) || ($("#err-email").html("Enter valid email!"), (n = 1)),
      $("#err-phone").html(""),
      ("" == i || i.length < 10) &&
        ($("#err-phone").html("Enter 10 digit valid phone number!"), (n = 1)),
      $("#err-password").html(""),
      "" == l
        ? ($("#err-password").html("Password is required!"), (n = 1))
        : l.length < 8 &&
          ($("#err-password").html(
            "Password should be more than or equal to 8 character long!"
          ),
          (n = 1)),
      1 != n)
    )
      return !0;
    console.log(s, t, o, i, "hhiii", webengage.state.getForever().luid),
      e.preventDefault();
  }),
  $("#phone").bind("keypress", function (e) {
    var s = e.which ? e.which : e.keyCode;
    return console.log(s), 43 == s || 32 == s || (s >= 48 && s <= 57);
  }),
  $("#phone").keyup(function (e) {
    /^0/.test(this.value) && (this.value = this.value.replace(/^0/, ""));
  }),
  location.href.indexOf("/account/register") &&
    $(function () {
      $("#firstname, #lastname").on("keypress", function (e) {
        if (32 == e.which) return !1;
      });
    }),
  $("#shopify-section-162505222825db2cef").slick({
    infinite: !0,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: !0,
    dots: !0,
  }),
  document.addEventListener("DOMContentLoaded", function () {
    $(".articleList").length > 13
      ? $("#loadMore").show()
      : $("#loadMore").hide(),
      $("#showless").hide(),
      $(".articleList").slice(0, 13).show(),
      $("#loadMore").on("click", function (e) {
        e.preventDefault(),
          $(".articleList:hidden").slice(0, 13).slideDown(),
          0 == $(".articleList:hidden").length && $("#loadMore").hide();
      }),
      $(function () {
        var e = function (e, s) {
          (this.el = e || {}),
            (this.multiple = s || !1),
            this.el
              .find(".article-title1")
              .on(
                "click",
                { el: this.el, multiple: this.multiple },
                this.dropdown
              );
        };
        (e.prototype.dropdown = function (e) {
          var s = e.data.el;
          ($next = ($this = $(this)).next()).slideToggle(),
            $this.parent().toggleClass("open1"),
            e.data.multiple ||
              s
                .find(".accordion-content1")
                .not($next)
                .slideUp()
                .parent()
                .removeClass("open1");
        }),
          new e($(".accordion-container1"), !1);
      });
  }),
  jQuery(".accordion-single-item.js-acc-item").click(function () {
    jQuery(this)
      .find(".accordion-single-title.js-acc-single-trigger")
      .toggleClass("open-acc"),
      jQuery(this).find(".accordion-single-content").toggleClass("active");
  });
var startX,
  scrollLeft,
  sliders = document.querySelectorAll(".items_scroll"),
  isDown = !1;
function disableLinks() {
  document.querySelectorAll(".items_scroll .ct-scroll-box").forEach((e) => {
    e.style.pointerEvents = "none";
  });
}
function enableLinks() {
  document.querySelectorAll(".items_scroll .ct-scroll-box").forEach((e) => {
    e.style.pointerEvents = "auto";
  });
}
sliders.forEach((e) => {
  e.addEventListener("mousedown", (s) => {
    (isDown = !0),
      e.classList.add("active"),
      (startX = s.pageX - e.offsetLeft),
      (scrollLeft = e.scrollLeft);
  }),
    e.addEventListener("mouseleave", () => {
      (isDown = !1), e.classList.remove("active"), enableLinks();
    }),
    e.addEventListener("mouseup", () => {
      (isDown = !1), e.classList.remove("active"), enableLinks();
    }),
    e.addEventListener("mousemove", (s) => {
      if (!isDown) return;
      s.preventDefault();
      let t = s.pageX - e.offsetLeft,
        o = (t - startX) * 1;
      (e.scrollLeft = scrollLeft - o), disableLinks();
    });
});
var ct_faq = document.querySelectorAll(".ct-footer--heading");
ct_faq.forEach((e) => {
  e.addEventListener("click", function () {
    e.classList.toggle("active"),
      e.closest(".ct-footer--manu-main").classList.toggle("active");
  });
});

// Add variant code start
function updateVariantInput(anchor) {
    const href = anchor.getAttribute('href');

    // Extract the variant ID from the href
    const urlParams = new URLSearchParams(href.split('?')[1] || '');
    let variantId = urlParams.get('variant');

    if (variantId) {
        variantId = variantId.split('#')[0]; // Extract the part before the hash

        // Find the parent with class 'v-stack'
        const parent = anchor.closest('.v-stack');

        // Find the child with class 'variantId' within that parent
        const variantInput = parent ? parent.querySelector('.variantId') : null;

        // Update the hidden input field with the variant ID
        if (variantInput) {
            variantInput.value = variantId;
        }
    }
}

// Select all rating badges
const anchors = document.querySelectorAll('.rating-badge');
anchors.forEach(anchor => {
    const observer = new MutationObserver(function(mutationsList) {
        for (let mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'href') {
                updateVariantInput(anchor);
            }
        }
    });

    observer.observe(anchor, { attributes: true });
    updateVariantInput(anchor); // Initial call to set the value
});
// Add variant code end

/* ------------------------------------------------------------------
   Product-card variant swatches -> keep Add to cart in sync.
   FIXED — sold-out products showed an active "Add to cart" on
   collection pages. `unavailable` was derived ONLY from the checked
   colour swatch, so swatch-less products (single variant) came out
   as available and this overwrote the correct server-rendered
   `value="Sold out" disabled` markup.
   ------------------------------------------------------------------ */
(function () {
  'use strict';

  function syncCard(card) {
    if (!card) return;

    var form = card.querySelector('form.bs');
    if (!form) return;

    var submit = form.querySelector('input[type="submit"]');
    if (!submit) return;

    // Remember the server-rendered (Liquid) availability, once per button,
    // before anything here modifies it.
    if (submit.dataset.initialUnavailable === undefined) {
      submit.dataset.initialUnavailable = String(
        submit.disabled || submit.classList.contains('soldout_class')
      );
    }

    var checked = card.querySelector('input.ColorSwatch__Radio:checked');
    var unavailable;

    if (checked) {
      // Card has colour swatches: the selected swatch is the source of truth.
      unavailable = checked.dataset.unavailable === 'true';

      if (checked.dataset.variantId) {
        var hidden = form.querySelector('.variantId');
        if (hidden) hidden.value = checked.dataset.variantId;
      }
    } else {
      // No swatches on this card: trust what the server rendered.
      unavailable = submit.dataset.initialUnavailable === 'true';
    }

    submit.disabled = unavailable;
    submit.value = unavailable
      ? (submit.dataset.soldOutText || 'Sold out')
      : (submit.dataset.addText || 'Add to cart');
    submit.classList.toggle('soldout_class', unavailable);
  }

  document.addEventListener('change', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('ColorSwatch__Radio')) {
      syncCard(e.target.closest('product-card'));
    }
  });

  // Last line of defence: never submit a sold-out card, even if some other
  // script re-enables the button. Capture phase, so it runs first.
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList || !form.classList.contains('bs')) return;

    var submit = form.querySelector('input[type="submit"]');
    if (submit && (submit.disabled || submit.classList.contains('soldout_class'))) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);

  function initAll() {
    document.querySelectorAll('product-card').forEach(syncCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Cards get re-rendered by filtering, sorting and pagination.
  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      for (var n = 0; n < records[r].addedNodes.length; n++) {
        var node = records[r].addedNodes[n];
        if (node.nodeType !== 1) continue;
        if (node.matches && node.matches('product-card')) syncCard(node);
        if (node.querySelectorAll) node.querySelectorAll('product-card').forEach(syncCard);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
